import React, { useEffect, useState } from "react";
import Button from "../../components/Button";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { handleBlur, handleShowPass } from "../../utility/action";
import { SignUpValidation } from "../../utility/Validation/validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { notify } from "../../utility/Toastify/toastify";
import poolData from "./AWSConfig/PoolData";
import { useNavigate } from "react-router-dom";
import "../../styles/pages/Auth/auth.css";
import Text from "../../components/auth/Text";
import ReferralModal from "../../components/auth/ReferralModal";
import GoogleSignUpButton from "./GoogleSignUpButton";
import { useDispatch } from "react-redux";
import { saveUserPass } from "../../redux/main/action/main";
import RecaptchaModal from "./login/RecaptchaModal";
import bgLogin from "../../asset/Images/LoginBackgound.png";
import AuthLayout from "../../components/layout/AuthLayout";

function readReferralCode(raw) {
  const value = String(raw || "").trim();
  if (!value) return "";
  return value.includes("=") ? value.split("=").pop() : value;
}

function SignUpPage({ emailHandler }) {
  //btn loading
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const params = useParams();
  const dispatch = useDispatch();
  //validation
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(SignUpValidation),
    defaultValues: {
      referralValue: readReferralCode(
        params.code || localStorage.getItem("referral") || "",
      ),
    },
  });

  const [referralValue, setReferralValue] = useState(() =>
    readReferralCode(params.code || localStorage.getItem("referral") || ""),
  );
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [submitData, setSubmitData] = useState({});
  const [checkCount, setCheckCount] = useState(0);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [showRecaptchaModal, setShowRecaptchaModal] = useState(false);
  const [isReferralFromParams, setIsReferralFromParams] = useState(false);

  // useEffect(() => {
  //   if (params.code) {
  //     const code = params.code.split("=")[1];
  //     setValue("referralValue", code);
  //     setReferralValue(code);
  //     setIsReferralFromParams(true);
  //   }
  // }, [params, setValue]);
  useEffect(() => {
    const code = readReferralCode(
      params.code || localStorage.getItem("referral") || "",
    );
    if (params.code || localStorage.getItem("referral")) {
      setIsReferralFromParams(true);
      if (params.code) {
        localStorage.setItem("referral", params.code);
      }
    }
    if (code) {
      setReferralValue(code);
      setValue("referralValue", code);
    }
  }, [params, setValue]);

  //form submit function
  const onsubmit = (data) => {
    // if (referralValue.length === 0 && checkCount === 0) {
    //   setSubmitData(data);
    //   setShowReferralModal(true);
    //   setCheckCount(1);
    //   return;
    // }
    const code = String(data.referralValue || "").trim();
    setReferralValue(code);
    setSubmitData(data);
    setLoading(true);

    emailHandler(data.email.toLowerCase());
    setShowRecaptchaModal(true);

    setCheckCount(0);
  };

  const closeRecaptchaModal = () => {
    setShowRecaptchaModal(false);
    setLoading(false);
  };

  return (
    <>
      <AuthLayout>
        <div className="authContent">
          <h1 className="auth-title">
            Sign up for an account
            {/*<p className="cc-auth__subtitle">*/}
            {/*  Simplify your crypto trading experience in minutes.*/}
            {/*  */}
            {/*</p>*/}
          </h1>

          <div className="cc-auth__social">
            <GoogleSignUpButton
              referralCode={referralValue}
              setLoading={setGoogleLoading}
            />
          </div>
          <form
            className="login100-form validate-form cc-auth__form"
            onSubmit={handleSubmit(onsubmit)}
          >
            <p className="form-header">Or continue with your email</p>
            <div className="cc-auth__field">
              <div
                className={`wrap-input100 validate-input ${
                  errors.username && "border-error"
                }`}
              >
                <input
                  className="input100 has-val"
                  placeholder="Username"
                  type={"text"}
                  defaultValue={""}
                  {...register("username")}
                  onBlur={(e) => handleBlur(e)}
                />
                {/*<span*/}
                {/*  className="focus-input100"*/}
                {/*  data-placeholder={"Username"}*/}
                {/*></span>*/}
              </div>
              {errors.username && (
                <span className="error-text">{errors.username.message}</span>
              )}
            </div>

            <div className="cc-auth__field">
              <div
                className={`wrap-input100 validate-input ${
                  errors.email && "border-error"
                }`}
              >
                <input
                  className="input100 has-val"
                  type={"text"}
                  placeholder="Email"
                  {...register("email")}
                  onBlur={(e) => handleBlur(e)}
                />
                {/*<span*/}
                {/*  className="focus-input100"*/}
                {/*  data-placeholder={"Email"}*/}
                {/*></span>*/}
              </div>
              {errors.email && (
                <span className="error-text">{errors.email.message}</span>
              )}
            </div>

            <div className="cc-auth__field">
              <div
                className={`wrap-input100 validate-input ${
                  errors.pass && "border-error"
                }`}
              >
                <span className="btn-show-pass">
                  <i
                    className="far fa-eye"
                    onClick={(e) => handleShowPass(e)}
                  ></i>
                </span>
                <input
                  className="input100 has-val"
                  type={"password"}
                  placeholder="Password"
                  {...register("pass")}
                  onBlur={(e) => handleBlur(e)}
                />
                {/*<span*/}
                {/*  className="focus-input100"*/}
                {/*  data-placeholder={"Password"}*/}
                {/*></span>*/}
              </div>
              {errors.pass && (
                <span className="error-text">{errors.pass.message}</span>
              )}
            </div>

            <div className="cc-auth__field">
              <div
                className={`wrap-input100 validate-input ${
                  errors.confirmPass && "border-error"
                }`}
              >
                <span className="btn-show-pass">
                  <i
                    className="far fa-eye"
                    onClick={(e) => handleShowPass(e)}
                  ></i>
                </span>
                <input
                  className="input100 has-val"
                  placeholder="Confirm Password"
                  type={"password"}
                  {...register("confirmPass")}
                  onBlur={(e) => handleBlur(e)}
                />
                {/*<span*/}
                {/*  className="focus-input100"*/}
                {/*  data-placeholder={"Confirm password"}*/}
                {/*></span>*/}
              </div>
              {errors.confirmPass && (
                <span className="error-text">{errors.confirmPass.message}</span>
              )}
            </div>

            <div className="cc-auth__field">
              <div
                className={`wrap-input100 validate-input ${
                  errors.referralValue && "border-error"
                }`}
              >
                <input
                  className="input100 has-val"
                  type={"text"}
                  placeholder="Referral Code (Optional)"
                  {...(() => {
                    const field = register("referralValue");
                    return {
                      ...field,
                      disabled: isReferralFromParams,
                      onBlur: (e) => {
                        field.onBlur(e);
                        handleBlur(e);
                      },
                      onChange: (e) => {
                        field.onChange(e);
                        setReferralValue(e.target.value.trim());
                      },
                    };
                  })()}
                />
                {/*<span*/}
                {/*  className="focus-input100"*/}
                {/*  data-placeholder={"Referral Code (Optional)"}*/}
                {/*></span>*/}
              </div>
              {errors.referralValue && (
                <span className="error-text">
                  {errors.referralValue.message}
                </span>
              )}
            </div>

            <div className="cc-auth__terms">
              <div className="acceptTermsWrapper cc-auth__termsInner">
                <div className="cc-auth__termsRow">
                  <input type={"checkbox"} {...register("terms")} />
                  <span className={"acceptTermsText"}>
                    I have read and agree to the{" "}
                    <a
                      href="https://cryptocrispy.com.au/terms_of_service.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      terms of service
                    </a>
                    .
                  </span>
                </div>

                {errors.terms && (
                  <span className="error-text">{errors.terms.message}</span>
                )}
              </div>
            </div>

            <Button
              ButtonText={"Sign Up"}
              className={"signup cc-auth__primaryButton"}
              loading={loading || googleLoading}
            />

            {/*<div className="cc-auth__divider" aria-hidden="true">*/}
            {/*  <span className="cc-auth__dividerLine"></span>*/}
            {/*  <span className="cc-auth__dividerText">or</span>*/}
            {/*  <span className="cc-auth__dividerLine"></span>*/}
            {/*</div>*/}

            <div className="cc-auth__footer">
              <span className="txt1">Already have an account?</span>
              <Link className="txt2" to="/auth/login">
                Login Instead
              </Link>
            </div>
          </form>
        </div>
      </AuthLayout>
      <ReferralModal
        data={submitData}
        setReferral={setReferralValue}
        setShow={setShowReferralModal}
        show={showReferralModal}
        submit={onsubmit}
      />
      {showRecaptchaModal && (
        <RecaptchaModal
          data={submitData}
          useCase="signup"
          open={showRecaptchaModal}
          onClose={closeRecaptchaModal}
          referralCode={referralValue}
        />
      )}
    </>
  );
}

export default SignUpPage;

// poolData.signUp(
//       data?.email.toLowerCase(),
//       data?.pass,
//       [
//         { Name: "email", Value: data?.email.toLowerCase() },
//         {
//           Name: "custom:custom_username",
//           Value: data?.username,
//         },
//         { Name: "custom:about_us", Value: "" },
//         {
//           Name: "custom:referal_code",
//           Value: referralValue.length < 10 ? "          " : referralValue,
//         },
//       ],
//       [],
//       (err, res) => {
//         if (res) {
//           emailHandler(res.user.username.toLowerCase());
//           dispatch(saveUserPass([data?.email.toLowerCase(), data?.pass]));
//           localStorage.setItem("userPass", [
//             data?.email.toLowerCase(),
//             data?.pass,
//           ]);
//           navigate("/auth/confirm");
//           setLoading(false);
//         }
//         if (err) {
//           notify(err?.message, "error");
//           setLoading(false);
//         }
//       },
//       null,
//     );
